import { CONTENT_ASSET_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import { ContentVideoAssetHistory, VideoAssetSet } from '../types/contentVideoType';

class ContentAssetService extends ApiService<VideoAssetSet> {
  public async fetchContentVideoAssets(contentId: number): Promise<VideoAssetSet[]> {
    const response: VideoAssetSet[] = (await this.fetchById(contentId)) as any;
    return response;
  }

  // 새로운 에셋 세트 저장 (기존)
  public async saveContentVideoAssets(
    contentId: number,
    videoAssetSets: VideoAssetSet[]
  ): Promise<void> {
    await Promise.all(
      videoAssetSets.map(async (videoAssetSet: VideoAssetSet) => {
        await this.create({
          content: contentId,
          video: videoAssetSet.video!,
          subtitle_ids: videoAssetSet.subtitle_ids!,
          is_default: videoAssetSet.is_default!,
          service_name: videoAssetSet.service_name,
          stream_manifests: videoAssetSet.stream_manifests,
          is_subtitles_embedded: videoAssetSet.is_subtitles_embedded,
          after_add_subtitle: videoAssetSet.after_add_subtitle || false,
        });
      })
    );
  }

  // 기존 에셋 세트 업데이트 (새로 추가)
  public async updateContentVideoAsset(
    assetId: number,
    updateData: Partial<VideoAssetSet>
  ): Promise<VideoAssetSet> {
    return await this.update(assetId, updateData);
  }

  // 에셋 세트 삭제 (필요시 사용)
  public async deleteContentVideoAsset(assetId: number): Promise<void> {
    await this.delete(assetId);
  }

  public async fetchContentVideoAssetHistory(
    contentId: number
  ): Promise<ContentVideoAssetHistory[]> {
    const response: ContentVideoAssetHistory[] = await this.fetchChildItemsByParentId(
      contentId,
      'histories/',
      new URLSearchParams({ content__id: contentId.toString() })
    );
    return response;
  }
}

export const contentAssetService = new ContentAssetService(CONTENT_ASSET_API_PATH);
